export default __webpack_public_path__ + "static/media/mastercard.aeb6752f.svg";